import React from 'react'
import {ReactComponent as FacebookIcon} from '../../../images/public/footer/facebook.svg'
import {ReactComponent as InstagramIcon} from '../../../images/public/footer/instagram.svg'
import {ReactComponent as PinterestIcon} from '../../../images/public/footer/pinterest.svg'
import {ReactComponent as LinkedinIcon} from '../../../images/public/footer/linkedin.svg'
import {ReactComponent as TwitterIcon} from '../../../images/public/footer/twitter.svg'
import {ReactComponent as YoutubeIcon} from '../../../images/public/footer/youtube.svg'

const Socialicons = () => {
  return (
    <div className='social_Wrapper'>
      <div className='social_Container'>
        <a href='https://www.facebook.com/KAAYTHEEASYWAY' target='_blank' rel="noopener noreferrer"><div className='social_icon'><FacebookIcon width="15px" height='20px'/></div></a>
        <a href='https://www.instagram.com/kaay_theeasyway/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><InstagramIcon width="15px" height='20px'/></div></a>
        <a href='https://www.pinterest.com/sesassociates3/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><PinterestIcon width="15px" height='20px'/></div></a>
        <a href='https://www.linkedin.com/company/%DA%A9%DB%92/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><LinkedinIcon width="15px" height='20px'/></div></a>
        <a href='https://twitter.com/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><TwitterIcon width="15px" height='20px'/></div></a>
        <a href='https://www.youtube.com/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><YoutubeIcon width="15px" height='20px'/></div></a>
      </div>
    </div>
  )
}

export default Socialicons
